import { InputRenderRow } from './styled/InputRenderRow.tsx';

interface AttachmentGroupEditorContainerProps {
  children: React.ReactNode;
  title: string;
  likeEmail?: boolean;
}

export function AttachmentGroupEditorContainer(
  props: AttachmentGroupEditorContainerProps,
) {
  const { children, likeEmail, title } = props;

  return (
    <div>
      {likeEmail ? (
        <InputRenderRow emailLike title={title} input={children} fixedWidth />
      ) : (
        <>
          <h4>{title}</h4>
          {children}
        </>
      )}
    </div>
  );
}
